/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ImportForm from "../../components/import/ImportForm";
import ImportDropDowns from "../../components/import/ImportDropDowns";
import ImportTable from "../../components/import/ImportTable";
import Loader from "../../components/common/dialog/Loader";
import { submitImport } from "../../services/ImportRequest";
import Papa from "papaparse";
import "./Import.css";
import { IMPORT_FAIL, IMPORT_FAIL_504 } from "../../utils/GlobalMessageConstants";
import { useTranslation } from "react-i18next";
import AlertView from "../../components/common/dialog/AlertView";
import { constructDCStore } from "../../utils/genericUse/CommonUse";
import * as XLSX from 'xlsx'
import { addSelectedSurveyId } from "../../../src/store/ImportSlices";
import { useDispatch } from "react-redux";
import { FILTER_DROPDOWN_DATA } from "../../utils/GlobalConstants";
const Import = ({ handleChangeForTab }) => {
  const dispatch = useDispatch();
  const [csvData, setCSVData] = useState([]);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [tableHeader, setTableHeader] = useState([]);
  const [isOverWrite, setIsOverWrite] = useState(false);
  const [isApendClicked, setIsApendCliked] = useState(true);
  const [isTableShow, setIsTableShow] = useState(false);
  const [fleetSurvetId, setFleetSurveyId] = useState("");
  const [vehicleTypeId, setVehicleTypeId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isImportBtnCliked, setIsImportBtnClicked] = useState(false);
  const [vehicleArr, setVehicleArr] = useState([]);
  const [fileSize, setFileSize] = useState(0);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [fileExtension, setFileExtension] = useState("");
  const [isUploadFail, setIsUploadFail] = useState(false);
  const [isUploadFail504, setIsUploadFail504] = useState(false);
  const [alertView, setAlertView] = useState({ year: false, vin: false , parts:false});
  const [partInformation, setPartInformation] = useState()
  const [vinStatus, setVinStatus] = useState([])
  const[tabelHeaderValue, setTableHeaderValue]=useState([])

  const { t } = useTranslation();
  const [isFileUploadClick, setIsFileUploadClick] = useState(false)
  const [surveyDetails, setSurveyDetails] = useState({
    makeModel: "",
    make: "",
    model: "",
    engine: "",
    vin: "",
    comments: "",
    subModel: "",
    year: "",
    unitNo: "",
  });
  const partTypes = FILTER_DROPDOWN_DATA?.map(item => item?.name);
  const suffixes = ["Position", "Qty", "Brand"];
  const otherTypes = ["Others"];
  const otherSuffixes = ["Other Name", "Qty", "Brand"];
    const[excludeHeader, setExcludeHeader]=useState([...suffixes,...otherSuffixes ,...partTypes])

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setSurveyDetails((prev) => {
      return { ...prev, [name]: value };
    });
    setShowErrorMsg(false);
    setIsUploadFail(false);
    payloadSurveySave(name, value);
  };

  const payloadSurveySave = (name, value) => {
    let formatedDataVehicleItem = initialFormating();
    let vehicleList = [...vehicleArr];

    if (!vehicleList?.length) {
      formatedDataVehicleItem?.forEach((data) => {
        vehicleList?.push({ [name]: data[value] });
      });
    } else {
      formatedDataVehicleItem?.forEach((data, index) => {
        vehicleList[index][name] = data[value];
      });
    }

    let onlyOneKey = false;
    if (!value) {
      vehicleList?.map((data) => {
        if (Object?.keys(data)?.length > 1) {
          delete data[name];
        } else {
          onlyOneKey = true;
        }
        return data;
      });
    }
    if (onlyOneKey) {
      vehicleList = [];
    }
    setVehicleArr(vehicleList);
  };
  const handleHideShowTable = () => {
    if (csvData?.length > 0) {
      setIsTableShow(true);
    }
  };

  const handleRefreshCall = () => {
    setTableHeader([]);
    setSurveyDetails({
      makeModel: "",
      make: "",
      model: "",
      engine: "",
      vin: "",
      comments: "",
      subModel: "",
      year: "",
      unitNo: "",
    });
  };
  const groupPartsByVehicle = (data) => {

    const grouped = {};

    data?.forEach((entry) => {
      entry?.partDetails?.forEach((part) => {
        const key = `${part?.make}|${part?.model}|${part?.engine}|${part?.makeModel}|${part?.model_Year}|${part?.vin}|${part?.unit}`;

        if (!grouped[key]) {
          grouped[key] = {
            make: part?.make,
            model: part?.model,
            engine: part?.engine,
            makeModel: part?.makeModel,
            model_Year: part?.model_Year,
            vin: part?.vin,
            unit: part?.unit,
            partDetails: [],
          };
        }

        grouped[key]?.partDetails?.push({
          type: part?.type,
          name: part?.name,
          filterType: part?.other_Name,
          Position: part?.Position,
          Qty: part?.Qty,
          Brand: part?.Brand,
        });
      });
    });

    return Object.values(grouped);
  };

  const handleFileUpload = (event) => {
isTableShow && handleRefreshCall();
const setHeaderExcludePush=[]
  const file = event?.target?.files[0];
  if (!file) return;
  const extension = file.name.split(".").pop().toLowerCase();
  setFileExtension(extension);
  setFileSize(file.size);
  setUploadedFileName(file.name);
  let currentPart = "";
  let suffixInd = 0;
  let otherCurrentPart = "";
  let suffixOtherIndex = 0;
  let lastTypeHeader = "";
  console.log(suffixInd,suffixOtherIndex )
  if (extension === "csv" || extension === "txt") {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      delimiter: extension === "txt" ? "\t" : ",",
      transformHeader: (header) => {
        if (partTypes?.includes(header)) {
          currentPart = header;
          suffixInd = 0;
          lastTypeHeader = "part";
          const transformed = `${header} Name`;
          setHeaderExcludePush.push(transformed)
          return transformed
        }
        if (otherTypes?.includes(header)) {
          otherCurrentPart = header;
          suffixOtherIndex = 0;
          lastTypeHeader = "other";
          const transformed = `${header} Name`;
          setHeaderExcludePush.push(transformed)
          return transformed
        }
        if (suffixes?.includes(header) && lastTypeHeader === "part") {
          const transformed = `${currentPart} ${header}`;
          suffixInd++;
          setHeaderExcludePush.push(transformed)
          return transformed;
        }
        if (otherSuffixes?.includes(header) && lastTypeHeader === "other") {
          const transformed = `${otherCurrentPart} ${header}`;
          suffixOtherIndex++;
           setHeaderExcludePush.push(transformed)
          return transformed;
        }
        return header;
      },
      complete: (results) => {
         const reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = (event) => {
          const data = event?.target?.result
          const workbook = XLSX.read(data, { type: 'binary' })
          const sheetName = workbook.SheetNames[0]
          const sheet = workbook.Sheets[sheetName]
          const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" })
           setExcludeHeader([...excludeHeader, ...setHeaderExcludePush])
          setCSVData(rows);
          setTableHeader(rows[0]);
        }
        reader.onerror = (err) => {

          console.error("File read error:", err);
          setIsUploadFail(true);
          setShowErrorMsg(true);

        }
        setPartInformation(results.data);
      },
    });
  } else if (extension === "xls" || extension === "xlsx") {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });
      const rawHeader = rows[0];
      const transformedHeader = rawHeader.map((header) => {
        if (partTypes?.includes(header)) {
          currentPart = header;
          suffixInd = 0;
          lastTypeHeader = "part";
           const transformed = `${header} Name`;
          setHeaderExcludePush.push(transformed)
          return transformed
        }
        if (otherTypes?.includes(header)) {
          otherCurrentPart = header;
          suffixOtherIndex = 0;
          lastTypeHeader = "other";
          const transformed = `${header} Name`;
          setHeaderExcludePush.push(transformed)
          return transformed
        }
        if (suffixes?.includes(header) && lastTypeHeader === "part") {
          const transformed = `${currentPart} ${header}`;
          suffixInd++;
          setHeaderExcludePush.push(transformed)
          return transformed
        }
        if (otherSuffixes?.includes(header) && lastTypeHeader === "other") {
          const transformed = `${otherCurrentPart} ${header}`;
          suffixOtherIndex++;
         setHeaderExcludePush.push(transformed)
          return transformed
        }
        return header;
      });
      const transformedRows = rows.map((row, index) => {
        if (index === 0) return transformedHeader;
        const obj = {};
        transformedHeader.forEach((key, i) => {
          obj[key] = row[i] ?? "";
        });
        return obj;
      });
      setExcludeHeader([...excludeHeader, ...setHeaderExcludePush])
      setCSVData(rows);
      setTableHeader(transformedHeader);
      setPartInformation(transformedRows.slice(1));
    };
    reader.onerror = (err) => {
      console.error("File read error:", err);
      setIsUploadFail(true);
      setShowErrorMsg(true);
    };
  } else {
    setIsUploadFail(true);
    setShowErrorMsg(true);
  }
};
 

  const handleFileInputClick = () => {
    document.getElementById("fileInputForImport").value = "";
    setIsFileUploadClick(true)
  };

  const initialFormating = () => {
    let uploadedcsv = [...csvData];
    let header = uploadedcsv.shift();
    let headerCol = tableHeader;
    let headerIndexes = [];
    headerCol.forEach((element) => {
      let index = header.findIndex((headerInd) => headerInd === element);
      headerIndexes.push(index);
    });
    let formatedDataVehicleItem = [];
    uploadedcsv.forEach((items) => {
      let initialVehicleObjList = {};
      items.forEach((element, index) => {
        if (headerIndexes.findIndex((headerInd) => headerInd === index) >= 0) {
          initialVehicleObjList[header[index]] = element;
        }
      });
      formatedDataVehicleItem.push(initialVehicleObjList);
    });
    return formatedDataVehicleItem;
  };

  const handleDisableImportBtn = () => {
    setIsImportBtnClicked(true);
    let condition_1 = fleetSurvetId !== "";
    let condition_2 =
      surveyDetails.vin !== "" &&
      (surveyDetails.makeModel !== "" ||
        surveyDetails.make !== "" ||
        surveyDetails.model !== "" ||
        surveyDetails.engine !== "" ||
        surveyDetails.comments !== "" ||
        surveyDetails.subModel !== "" ||
        surveyDetails.year !== "" ||
        surveyDetails.unitNo !== "");
    let condition_3 = surveyDetails.make !== "" && surveyDetails.model !== "";
    if (condition_1 && (condition_2 || condition_3)) {
      return true;
    } else if (fleetSurvetId === "") {
      handleScrollToTop();
      return false;
    } else {
      setShowErrorMsg(true);
      handleScrollToTop();
    }
  };

  const removeSpace = () => {
    return vehicleArr.map((obj) => {
      if (obj.hasOwnProperty("year" && obj.year !== null)) {
        obj.year = obj.year.trim();
      }
      return obj;
    });
  };

  const isNumeric = (value) => {
    return /^\d+$/.test(value);
  };
  const isObjectValid = (obj) => {
    return Object.values(obj).every(value => value !== undefined && value !== '' && value !== null);
  };
  const checkNonNumericYear = () => {
    for (let obj of vehicleArr) {
      if ("year" in obj && isObjectValid(obj) && !isNumeric(obj.year)) {
        return true;
      }
    }
    return false;
  };

  const handleSubmitImport = async () => {
    if (handleDisableImportBtn()) {
      if (vehicleArr[0].hasOwnProperty("year") || vehicleArr[0].hasOwnProperty("vin")) {
        let isNonNumericValueFound = checkNonNumericYear();

        if (isNonNumericValueFound) {
          setAlertView({ year: isNonNumericValueFound });
        }
        else {
          handleImport();
        }
      }
      else {
        handleImport();
      }
    }
  };


  const processPartInfo = (payload) => {
    let lastItem = {
      Make: "",
      Model: "",
      makeModel: "",
      submodel: "",
      Engine: "",
      year: "",
      vin: "",
      Unit: "",
    };
    const transformed = partInformation?.map((row) => {
      const make = row[surveyDetails.make] || lastItem.Make;
      const model = row[surveyDetails.model] || lastItem.Model;
      const makeModel = row[surveyDetails.makeModel] || lastItem.makeModel;
      const submodel = row[surveyDetails.subModel] || lastItem.submodel;
      const engine = row[surveyDetails.engine] || lastItem.Engine;
      const model_Year = row[surveyDetails.year] || lastItem.year;
      const vin = row[surveyDetails.vin] || lastItem.vin;
      const unit = row[surveyDetails.unitNo] || lastItem.Unit

      lastItem = {
        make: make,
        model: model,
        makeModel,
        submodel,
        engine,
        model_Year,
        vin,
        unit,
      };
  const allEmpKeys = Object.values(row)?.every(
  (value) => !value || (typeof value === "string" && value.trim() === "")
);
      if (allEmpKeys) return null;
      const partDetails = partTypes?.map((type) => ({
        type,
        name: row[`${type} Name`] || "",
        Position: row[`${type} Position`] || "",
        Qty: row[`${type} Qty`] || "",
        Brand: row[`${type} Brand`] || "",
        make: make,
        model: model,
        engine,
        makeModel,
        model_Year,
        vin,
        unit,
      }));
      const hasAnyPart = partDetails?.some(
        (part) => part?.name || part?.Position || part?.Qty || part?.Brand
      );
      const otherPartDetails = otherTypes?.map((type) => ({
        type,
        name: row[`${type} Name`] || "",
        other_Name: row[`${type} Other Name`] || "",
        Qty: row[`${type} Qty`] || "",
        Brand: row[`${type} Brand`] || "",
        make: make,
        model: model,
        engine,
        makeModel,
        model_Year,
        vin,
        unit,
      }));

      const hasAnyOtherPart = otherPartDetails.some(
        (part) => part?.name || part?.other_Name || part?.Qty || part?.Brand
      );
      const partInfo = hasAnyPart ? partDetails : [];
      const otherInfo = hasAnyOtherPart ? otherPartDetails : [];
      const mergeData = [...partInfo, ...otherInfo]
      return mergeData?.length > 0 ? { partDetails: mergeData } : null;
    })
      .filter(Boolean);
    const partInfo = groupPartsByVehicle(transformed)
const partInfoProcessed =partProcessed(payload, partInfo)
    return updatePartInfo(partInfoProcessed)
  }
  const updatePartInfo=(partInfoProcessed)=>{
    if(partInfoProcessed){
   const response = partInfoProcessed?.map(item => {
  if (item?.partDetails?.length > 0) {
    const updatedPartDetails = item?.partDetails?.map(part => {
      const matchedFilter = FILTER_DROPDOWN_DATA?.find(filter => filter?.name === part?.partType);
      return {
        ...part,
        partType: matchedFilter?.partType || part?.partType
      };
    });
    return {
      ...item,
      partDetails: updatedPartDetails
    };
  }
  return item;
});
return response;
    }else{return []}
  }
  const partProcessed = (payload, partInfo) => {
    const isEqual = (obj1, obj2) => {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);
      if (keys1.length !== keys2.length){return false;}
      return keys1.every(key => obj2.hasOwnProperty(key) && obj1[key] === obj2[key]);
    };
    const removeDuplicateObject = arr => {
      const unique = [];
      arr.forEach(obj => {
        if (!unique.some(u => isEqual(u, obj))) {
          unique.push(obj);
        }
      });
      return unique;
    };
    const mergedData = payload.map(item => {
      let keyValue = 'makeModel'
      const allModelUndefined = partInfo?.every(obj => obj?.makeModel === undefined || obj?.makeModel === '');
      if (allModelUndefined) {keyValue = 'vin'}
      const matchedParts = partInfo?.filter(dat => dat[keyValue] === item[keyValue]).flatMap(di => di?.partDetails || []);
      const uniqueParts = removeDuplicateObject(matchedParts);
      return {
        ...item,
        ...(uniqueParts.length > 0 && { partDetails: uniqueParts })
      };
    });
//     const partInfoKeyChange = (partDetails) => {
//       const transformedParts = partDetails?.map(part => {
//         const {
//           type,
//           name,
//           Qty,
//           Brand,
//           filterType
//         } = part;
//         const newPart = {
//           partType: type,
//           partNumber: name,
//           quantity: Qty,
//           brand: Brand
//         };
//         if (filterType) {
//           newPart.filterType = filterType;
//         }
//         return newPart;
//       });
//       return transformedParts
//     }
//     const clearPartInfo = (arr_) => {
//       const cleanUpData = arr_?.filter(item =>
//   suffixes?.some(key =>
//     typeof item[key] === "string" && item[key].trim() !== ""
//   )
// );
//       return partInfoKeyChange(cleanUpData)
//     }




// Normalize helper: convert empty strings to null, keep numbers as-is.
const toNull = (v) => {
  if (v === null || v === undefined) return null;
  if (typeof v === "string") {
    const trimmed = v.trim();
    return trimmed === "" ? null : trimmed;
  }
  // For numbers/booleans/others, return as-is
  return v;
};
 
const partInfoKeyChange = (partDetails) => {
  const transformedParts = partDetails?.map((part) => {
    const { type, name, Qty, Brand, filterType, other_Name } = part;
 
    const newPart = {
      partType: type,            
      partNumber: toNull(name),  
      quantity: toNull(Qty),     
      brand: toNull(Brand),      
    };
 
    const ft = filterType ?? other_Name;
    if (ft !== undefined && ft !== null) {
      const v = toNull(ft);
      if (v !== null) newPart.filterType = v;
    }
 
    return newPart;
  });
 
  return transformedParts;
};
 
const clearPartInfo = (arr_) => {
  const cleanUpData = arr_?.filter((item) => {
    // name can be number or string
    const hasPartNumber =
      item?.name !== undefined &&
      item?.name !== null &&
      String(item.name).trim() !== "";
 
    // // Suffixes: count non-empty strings 
    // const hasAnySuffix = suffixes?.some((key) => {
    //   const val = item?.[key];
    //   if (val === undefined || val === null) return false;
    //   if (typeof val === "number") {
    //     return  val;
    //   }
    //   if (typeof val === "string") {
    //     return val.trim() !== "";
    //   }
    //   return false;
    // });
    const hasOtherName =
      (item?.other_Name && String(item.other_Name).trim() !== "") ||
      (item?.["Other Name"] && String(item["Other Name"]).trim() !== "");
 
    return hasPartNumber || hasOtherName;
 
    //return hasPartNumber || hasAnySuffix || hasOtherName;
  });
 
  return partInfoKeyChange(cleanUpData);
};
 
    const mergeData = mergedData?.map(item => {
      return { ...item, partDetails: clearPartInfo(item?.partDetails) }
    })
    return mergeData
  }
//   const handleImports = async () => {
//     setAlertView({});
//     let updatedVehicle = removeSpace();
//     let vehicleWitoutEmptyObj = updatedVehicle?.filter(item => {
//       return Object.values(item).some(value => value !== "" && value !== undefined);
//     })
//     let vehicleForPayload = vehicleWitoutEmptyObj?.map((obj) => {
//       if (obj["unitNo"]) {
//         obj["unitNo"] = constructDCStore(obj.unitNo);
//       }
//       if ("year" in obj && !isNumeric(obj.year)) {
//         delete obj["year"];
//       }
//       return obj;
//     });
//     let finalPayloadObj = {
//       metaData: {
//         updateType: isOverWrite ? 1 : 0,
//       },
//       surveyId: fleetSurvetId,
//       vehicleTypeId: vehicleTypeId,
//       vehicles: processPartInfo(vehicleForPayload),
//     };
//     setIsLoading(true);
//     try {
//       const data = await submitImport(finalPayloadObj);
//       if (data.status === 200) {
//         setIsLoading(false);
//         const result = data?.data?.vehicles?.filter(item => item?.vinFlag === 'No' || !item?.vinFlag)
//           .map(it => ({ vin: it?.vin, message: it?.vinValid }));
//          const partResult = data?.data?.vehicles?.some(item =>
//     item?.hasOwnProperty('isPartDetailsFetched') && item.isPartDetailsFetched === false
// );
//         if (result?.length > 0 || partResult) {
//           setVinStatus(result?.length > 0?result:[])
//           setAlertView({ parts: partResult,vin: true })
//         } else {
//           handleChangeForTab("", 0);
//           dispatch(addSelectedSurveyId(fleetSurvetId));
//         }
//       } else {
//         setIsUploadFail(true);
//         setIsLoading(false);
//         setTimeout(() => {
//           handleScrollToTop();
//         }, 500);
//       }
//     } catch (err) {
//       if (err?.response?.status === 504) {
//         setIsUploadFail504(true);
//       }
//       else {
//         setIsUploadFail(true);
//       }
//       setIsLoading(false);
//       setTimeout(() => {
//         handleScrollToTop();
//       }, 500);
//     }
//   };

// --- Batching utilities ---
const chunkArray = (arr, size) => {
  if (!Array.isArray(arr) || size <= 0) return [arr || []];
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) chunks.push(arr.slice(i, i + size));
  return chunks;
};
 

const submitImportBatched = async (payload, batchSize = 100) => {
  const vehicles = payload?.vehicles || [];
 

  if (vehicles.length <= batchSize) {
    const resp = await submitImport(payload);
    if (!resp || resp.status !== 200) {
      const error = new Error('Non-200 response');
      error.response = resp || { status: 0, data: null };
      throw error;
    }
    return resp;
  }
 
  const batches = chunkArray(vehicles, batchSize);
  let combinedVehicles = [];
  let lastOkData = null;
 const originalMeta = payload?.metaData ?? {};
  const isOverwrite = originalMeta?.updateType;
 
  for (let i = 0; i < batches.length; i++) {


  // For the first batch, keep whatever updateType the payload has.
  // For subsequent batches (i > 0), if overwrite was chosen, force append (0).
  const nextUpdateType = (i === 0 || !isOverwrite) ? originalMeta.updateType : 0;
 
  const batchPayload = {
    ...payload,
    metaData: {
      ...originalMeta,
      updateType: nextUpdateType,   
    },
    vehicles: batches[i],
  };



    // const batchPayload = { ...payload, vehicles: batches[i] };
 
    const resp = await submitImport(batchPayload);
 
    if (!resp || resp.status !== 200) {
      const error = new Error('Non-200 response during batched import');
      error.response = resp || { status: 0, data: null };
      throw error;
    }
 
    lastOkData = resp?.data || null;
    const batchVehicles = resp?.data?.vehicles ?? [];
    if (Array.isArray(batchVehicles)) {
      combinedVehicles = combinedVehicles.concat(batchVehicles);
    }
  }
 
 
  return {
    status: 200,
    data: {
      ...(lastOkData || {}),
      vehicles: combinedVehicles,
    },
  };
};
 
const handleImport = async () => {
  setAlertView({});
  let updatedVehicle = removeSpace();
  let vehicleWitoutEmptyObj = updatedVehicle?.filter(item => {
    return Object.values(item).some(value => value !== "" && value !== undefined);
  });
  let vehicleForPayload = vehicleWitoutEmptyObj?.map((obj) => {
    if (obj["unitNo"]) {
      obj["unitNo"] = constructDCStore(obj.unitNo);
    }
    if ("year" in obj && !isNumeric(obj.year)) {
      delete obj["year"];
    }
    return obj;
  });
  let finalPayloadObj = {
    metaData: {
      updateType: isOverWrite ? 1 : 0,
    },
    surveyId: fleetSurvetId,
    vehicleTypeId: vehicleTypeId,
    vehicles: processPartInfo(vehicleForPayload),
  };
 
  setIsLoading(true);
 
  try {

    const data = await submitImportBatched(finalPayloadObj, 100);
    const status = data?.status;
    const vehiclesResp = data?.data?.vehicles || [];
 
    if (status === 200) {
      const result = vehiclesResp
        ?.filter(item => item?.vinFlag === 'No' || !item?.vinFlag)
        .map(it => ({ vin: it?.vin, message: it?.vinValid }));
 
      const partResult = vehiclesResp?.some(item =>
        item?.hasOwnProperty('isPartDetailsFetched') && item.isPartDetailsFetched === false
      );
 
      if ((result?.length ?? 0) > 0 || partResult) {
        setVinStatus((result?.length ?? 0) > 0 ? result : []);
        setAlertView({ parts: partResult, vin: true });
      } else {
        handleChangeForTab("", 0);
        dispatch(addSelectedSurveyId(fleetSurvetId));
      }
    } else {
      
      setIsUploadFail(true);
      setTimeout(() => {
        handleScrollToTop();
      }, 500);
    }
  } catch (err) {
    
    const status = err?.response?.status;
 
    if (status === 504) {
      setIsUploadFail504(true);
    } else {
      setIsUploadFail(true);
    }
 
    setTimeout(() => {
      handleScrollToTop();
    }, 500);
  } finally {
    setIsLoading(false);
  }
};
 


  
  const handleCloseAlertView = () => {
    setAlertView({});
  };

  const handleScrollToTop = () => {
    document.documentElement.scrollTop = 0;
  };

  const handleOverWriteRadio = () => {
    setIsOverWrite(true);
    setIsApendCliked(false);
  };
  const handleApendRadio = () => {
    setIsOverWrite(false);
    setIsApendCliked(true);
  };

  const handleClearFleetSurveyId = () => {
    setFleetSurveyId("");
  };
  const handleChangeFleetSurveyName = (e) => {
    e.preventDefault();
    setFleetSurveyId(e.target.value);
  };
  const handleChangeVehicleType = (e) => {
    e.preventDefault();
    setVehicleTypeId(e.target.value);
  };
  const handleHomePageNaviation = () => {
    handleChangeForTab("", 0);
    dispatch(addSelectedSurveyId(fleetSurvetId));
  }

  useEffect(() => {
  if (tableHeader?.length > 0) {
   
    const headerVal = tableHeader.filter(
      (item) => !excludeHeader?.includes(item)
    );
    setTableHeaderValue(headerVal);
  } else {
    setTableHeaderValue([]);
  }
}, [tableHeader]);
 
  
  return (
    <React.Fragment>
      <Box component="fieldset" className="fieldset-style import-box-style">
        <Grid
          container
          spacing={2}
          sx={{
            padding: 0,
            margin: 0,
            flexWrap: 'wrap',
          }}
        >
          {/* Left Section */}
          <Grid item xs={12} md={5} className="left-grid-style">
            <Box className="import-box-wrning-msg">
              {t("tab2.message")}
            </Box>

            {fileSize > 5 * 1024 * 1024 && (
              <span className="error-msg-5mb">
                {t("tab2.contents.messages.uploadErrMsg")}
              </span>
            )}
            {isUploadFail && (
              <span className="upload-fail-error-msg">{IMPORT_FAIL}</span>
            )}
            {isUploadFail504 && (
              <span className="upload-fail-error-msg-504">{IMPORT_FAIL_504}</span>
            )}

            <ImportForm
              testid="importform"
              handleFileUpload={handleFileUpload}
              handleFileInputClick={handleFileInputClick}
              isFileUploadClick={isFileUploadClick}
              uploadedFileName={uploadedFileName}
              handleHideShowTable={handleHideShowTable}
              handleChangeFleetSurveyName={handleChangeFleetSurveyName}
              handleChangeVehicleType={handleChangeVehicleType}
              vehicleTypeId={vehicleTypeId}
              fleetSurvetId={fleetSurvetId}
              isImportBtnCliked={isImportBtnCliked}
              csvData={csvData}
              disabled={csvData.length === 0 || fileSize > 5 * 1024 * 1024}
              fileExtension={fileExtension}
              handleClearFleetSurveyId={handleClearFleetSurveyId}
            />
          </Grid>

          {/* Right Section */}
          <Grid item xs={12} md={7}>
            <ImportDropDowns
              tableHeader={tabelHeaderValue}
              handleChange={handleChange}
              surveyDetails={surveyDetails}
              isImportBtnCliked={isImportBtnCliked}
              showErrorMsg={showErrorMsg}
            />
          </Grid>
        </Grid>

        <br />

        {/* Table Section */}
        {isTableShow && (
          <Box
            sx={{
              width: '100%',
              border: 'none',
              maxWidth: '100vw',
            }}
          >
            <ImportTable csvData={csvData} />
          </Box>
        )}

        {/* Radio Buttons */}
        <Box>
          <FormControl
            className="radio-group-container"
            sx={{
              visibility: !isTableShow ? 'hidden' : 'visible',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
            }}
          >
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="Overwrite"
                control={
                  <Radio
                    data-testid="Overwrite-radio"
                    onClick={() => handleOverWriteRadio()}
                    checked={isOverWrite}
                  />
                }
                label={t("tab2.contents.upload_section.Overwrite")}
              />
              <FormControlLabel
                value="Paste"
                control={
                  <Radio
                    data-testid="paste-radio"
                    onClick={() => handleApendRadio()}
                    checked={isApendClicked}
                  />
                }
                label={t("tab2.contents.upload_section.Paste")}
              />
            </RadioGroup>
          </FormControl>
        </Box>

        {/* Import Button */}
        <Box>
          <FormControl
            fullWidth
            sx={{
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              gap: 2,
              visibility: !isTableShow ? 'hidden' : 'visible',
            }}
          >
            <Box sx={{ minWidth: '190px' }}>
              <label>
                7. {t("tab2.contents.upload_section.Import_Data")} :
              </label>
            </Box>
            <Box>
              <button
                className="button-style button-padding"
                data-testid="import-button-from-import-page"
                onClick={() => handleSubmitImport()}
              >
                {t("tab2.contents.upload_section.Import")}
              </button>
            </Box>
          </FormControl>
        </Box>
      </Box>

      {/* Loader */}
      {isLoading && <Loader className="Loader-style" />}

      {/* Alert View */}
      <AlertView
        isOpen={alertView?.year || alertView?.vin||alertView?.parts}
        handleCloseAlertView={alertView?.vin||alertView?.parts? handleHomePageNaviation: handleCloseAlertView}
        handleImport={alertView?.vin ? handleHomePageNaviation : handleImport}
        vinStatus={vinStatus}
        isImportOnly={alertView?.vin|| alertView?.parts}
        isPart={alertView?.parts}
        valid={
          alertView?.year && alertView?.vin
            ? 'year$vin'
            : alertView?.year
              ? 'year'
              : 'vin'
        }
      />

      {/* Optional Dialog View (commented) */}
      {/* <DialogView
    open={isPopup}
    testid={'vin_status'}
    handleClose={(e) => closeVinStatus(e)}
    width={"33%"}
    maxWidth={"75em!important"}
    heading={WIN_STATUS}
    childComponet={
      <>
        <ImportListView data={vinStatus} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            bgcolor: 'background.paper',
            borderRadius: 1,
          }}
        >
          <div onClick={(e) => closeVinStatus(e)}>
            <ButtonView label='Okay' />
          </div>
        </Box>
      </>
    }
  /> */}
    </React.Fragment>
  );
};

export default Import;
